import React, { useEffect, useState, useRef, forwardRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router";
import moment from "moment";
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';

import routes from "../../libs/routes";
// import consts from '../../libs/consts';

import { logIn, logOut } from "../../redux/usersSlice";
import { open, close } from "../../redux/popupSlice";
import { loadingStart, loadingEnd } from "../../redux/loadingSlice";

import * as API from "../../libs/service";

import Popup01 from "../popup/Popup01"
import PopupPlanModel from "../popup/PopupPlanModel"
import { numFormat } from "../../libs/utils";

export default function PopupSaleService(props) {
    const { 
        title,
        subTitle,
        text, 
        lefttext,
        width, 
        button, 
        buttonCancel, 
        func, 
        setFunc, 
        noneLoading, 
        top,
        cancelFunc,
        x_btn,
        cancelText,
        longButton,
        max_width,
        popType,
        planToggle,
        priceProMonth,
        priceProYear,
        pay_card=false,
        mainCard={},
        nocardbuttonType,
        payData=()=>{},
        showWon=true,
        setinvoicecker=()=>{}
    } = props;
    

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { mbData } = useSelector((s) => s.usersReducer);
    const lang = useSelector(state => state.langReducer.lang);

    const [maxWidthCut, setMaxWidthCut] = useState(max_width);

    const [saleStep, setSaleStep] = useState(1);
    const [numBtn1, setNumBtn1] = useState(true);
    const [numBtn2, setNumBtn2] = useState(false);
    const [invoiceValue, setInvoicevalue] = useState('');
    const [invoiceErr, setInvoiceErr] = useState(0);
    const [planPopRadioValue, setPlanPopRadioValue] = useState(1);


    useEffect(() => {
        if (!buttonCancel && !button && top) {
            const popup = document.querySelector(".popup.show");
            /* console.log(popup); */
            if (popup) popup.classList.add("popup_top");
            const timeout = setTimeout(() => {
                dispatch(close());
            }, 1000);
            popup.addEventListener("click", () => {
                dispatch(close());
                clearTimeout(timeout);
            });
        }
    }, []);

    const setFunction = () => {
        if(setFunc) setFunc();
        dispatch(close());
    };

    const setFunctionSet = () => {
        if(setFunc) setFunc();
    };

    const InputChange = (event) => {
        const { name, value } = event.target;

        if(name === "invoice") {
            setInvoicevalue(value)
        }
    }

    const checkboxFunc = (value) => {
        setPlanPopRadioValue(value)
    };

    const SaleServiceStepFunc = async() => {

        if(saleStep === 1) {
            if(!invoiceValue) {
                setInvoiceErr(1);
            } else {
                setInvoiceErr(0);
                dispatch(loadingStart());
                const result = await API.xsollaApis("user/invoiceCker", { invoiceCode: invoiceValue });
                console.log(result);
                if(result?.status === 200){
                    if(result?.result?.invoices?.length > 0){
                        setSaleStep(3);
                        setinvoicecker(invoiceValue);
                        
                        dispatch(close());
                    } else {
                        setInvoiceErr(2);
                    }
                } else {
                    if(result?.status === 401){
                        setInvoiceErr(3);
                    } else {
                        setInvoiceErr(2);
                    }
                }
                dispatch(loadingEnd());
                return;
            }
        }

        if(saleStep === 2) {
            setSaleStep(3);
            setNumBtn2(true);
            setNumBtn1(false);
        }
    }

    const SaleModelBuyFunc = () => {
        if(planPopRadioValue === 1) {
            dispatch(open({
                component: 
                    <PopupPlanModel 
                        max_width={'480px'}
                        plan_type={'Pro'}
                        saleService={true}
                        longButton={lang === 0 ? '구독하기' : 'Subscribe'}
                        pay_card={mainCard ? true : false}
                        mainCard={mainCard}
                        nocardbuttonType={nocardbuttonType}
                        payData={payData}
                        seetnotviewer={true}
                        priceProMonth={priceProMonth}
                        priceProYear={priceProYear}
                        invoiceCode={invoiceValue}
                        showWon={showWon}
                    />
            }));
        }

        if(planPopRadioValue === 2) {
            dispatch(open({
                component: 
                    <PopupPlanModel 
                        max_width={'480px'}
                        plan_type={'Art Pass'}
                        pay_card={true}
                        saleService={true}
                        longButton={'구독하기'}
                    />
            }));
        }

        if(planPopRadioValue === 3) {
            dispatch(open({
                component: 
                    <PopupPlanModel 
                        max_width={'480px'}
                        plan_type={'All-In-One'}
                        pay_card={true}
                        saleService={true}
                        longButton={'구독하기'}
                    />
            }));
        }
    }

    return (
        <>
            <div 
                className={"popup_default01 sale_service_pop_mobile"} 
                style={{ 
                    maxWidth: max_width ? maxWidthCut : '400px', 
                    width: '100%', 
                    marginLeft: 10, 
                    marginRight: 10,
                }}
                >
                {x_btn &&
                    <div 
                        className="popup_x_btn_box sale_service"
                    >   
                        <p className="title">
                        {lang === 0 ?
                            <>
                                할인 혜택 받기
                            </>
                            :
                            <>
                                Claim your discount
                            </>
                        }                            
                        </p>
                        <img src={require("../../assets/images/exit-icon.svg").default} 
                            className="popup_x_btn" 
                            onClick={() => {
                                dispatch(close());
                            }}
                            style={{ cursor: isBrowser ? 'pointer' : 'auto' }}
                        />
                    </div>
                }
                <div 
                    className={`popup_content_box sale_service plan_model`}
                    style={{

                    }}
                >
                    <div className="title_box">
                        {saleStep != 3 ? <p>1. {lang === 0 ? "INVOICE 확인" : "Check the INVOICE"}</p> : <p>2. {lang === 0 ? "구독 상품 선택" : "Select a subscription product"}</p>}

                        <div className="step_box">
                            {numBtn2 ? 
                                <img src={require("../../assets/icon/sale_step_suc.svg").default}/>
                                :
                                <p className={`step ${numBtn1 ? 'on' : ''}`}>1</p>
                            }
                            <img src={require("../../assets/icon/sale_step_center.svg").default}/>
                            <p className={`step ${numBtn2 ? 'on' : 'off'}`}>2</p>
                        </div>
                    </div>

                    {saleStep === 1 &&
                        <>
                            <div className="education_pop_box sale_service">
                                <div className="text_box">
                                    <img src={require("../../assets/icon/chk_emoji.svg").default} />
                                    
                                    {lang === 0 ? "연 구독 상품에 한함" : "Applicable to annual subscription only"}
                                </div>
                                <div className="text_box">
                                    <img src={require("../../assets/icon/chk_emoji.svg").default} />
                                    
                                    {lang === 0 ? "계정당 1회 한정" : "Limited to one use per account"}
                                </div>
                            </div>

                            <div className="input_box">
                                <p className="title">{lang === 0 ? "에셋 스토어 Invoice 또는 Order ID 입력" : "Enter Asset Store Invoice Number or Order ID"}</p>

                                <div className="area_box" style={{ height: 'auto'}}>
                                    
                                    <input 
                                        type="text"
                                        className={`active`}
                                        name="invoice"
                                        placeholder={lang === 0 ? 'Invoice 혹은 Order ID 입력' : 'Enter Invoice Number or Order ID.'}
                                        maxLength={20}
                                        onChange={InputChange}
                                        value={invoiceValue}
                                        style={{
                                            border: '1px solid #ddd', height: 50, padding: '0px 20px',
                                            borderRadius: 10
                                        }}
                                    />

                                    {/* {!invoiceValue &&
                                        <div className="place">
                                            {lang === 0 ? "INVOICE NO.를 쉼표로 구분하여 입력하세요." : "Enter INVOICE NOs separated by commas."}<br />
                                            ex) IN123456789, IN987654321
                                        </div>
                                    } */}
                                </div>

                                {invoiceErr === 1 &&<span className="err_msg id" style={{ margin: '0'}}>{lang === 0 ? "INVOICE또는 Order ID를 입력해 주세요." : "Please enter the INVOICE or Order ID."}</span>}
                                {invoiceErr === 2 &&<span className="err_msg id" style={{ margin: '0'}}>{lang === 0 ? "확인할 수 없는 INVOICE 또는 Order ID 입니다." : "The invoice or order ID could not be found."}</span>}
                                {invoiceErr === 3 &&<span className="err_msg id" style={{ margin: '0'}}>{lang === 0 ? "이미 사용된 INVOICE 또는 Order ID 입니다." : "This invoice or order ID has already been used."}</span>}
                            </div>
                        </>
                    }

                    {saleStep === 2 &&
                        <>
                            <div className="education_pop_box sale_service">
                                <div className="text_box">
                                    <img src={require("../../assets/icon/chk_emoji.svg").default} />
                                    {lang === 0 ? "연 구독 상품에 1회 한함" : "Limited to one time per annual subscription."}
                                </div>
                                <div className="text_box">
                                    <img src={require("../../assets/icon/chk_emoji.svg").default} />
                                    {lang === 0 ? "50% 할인" : "50% discount"}
                                </div>
                            </div>

                            <div className="invoice_box">
                                <div className="invoice_suc">
                                    <p>IN123456789</p>
                                    <p>IN123456789</p>
                                    <p>IN123456789</p>
                                    <p>IN123456789</p>
                                    <p>IN123456789</p>
                                    <p>IN123456789</p>
                                    <p>IN123456789</p>
                                    <p>IN123456789</p>
                                </div>

                                <div className="invoice_fail">
                                    <div>
                                        <p>IN123456789</p>
                                        <span>{lang === 0 ? "중복" : "Duplicate"}</span>
                                    </div>
                                    <div>
                                        <p>IN123456789</p>
                                        <span>{lang === 0 ? "이미 사용됨" : "Already used"}</span>
                                    </div>
                                    <div>
                                        <p>IN123456789</p>
                                        <span>{lang === 0 ? "불알치" : "Mismatch"}</span>
                                    </div>
                                </div>
                            </div>
                        </>
                    }

                    {saleStep === 3 &&
                        <div className="pop_scroll_box sale_service">
                            <div className="price_option">
                                <p className="title">{lang === 0 ? "1개의 시트를 구매하실 수 있습니다." : "You can purchase 1 sheets."}</p>

                                <label className={`option_chk ${planPopRadioValue === 1 ? 'on' : ''}`} htmlFor="price_option1">
                                    <input 
                                        type="radio" 
                                        name="price_option" 
                                        id="price_option1"
                                        onChange={() => checkboxFunc(1)}
                                        checked={planPopRadioValue === 1}
                                    />

                                    <div className="price">
                                        <p>UModeler X Pro</p>
                                        <div>
                                            <p>{(showWon ? '₩' : '$')}{numFormat(planToggle === 1 ? priceProMonth : priceProYear)} </p>
                                            <span>→ {(showWon ? '₩' : '$')}{numFormat(planToggle === 1 ? Math.floor(priceProMonth*0.5) : Math.floor(priceProYear*0.5))}</span>
                                        </div>
                                    </div>
                                </label>

                                {/* <label className={`option_chk ${planPopRadioValue === 2 ? 'on' : ''}`} htmlFor="price_option2">
                                    <input 
                                        type="radio" 
                                        name="price_option" 
                                        id="price_option2"
                                        onChange={() => checkboxFunc(2)}
                                        checked={planPopRadioValue === 2}
                                    />

                                    <div className="price">
                                        <p>UModeler X Art Pass</p>
                                        <div>
                                            <p>{(showWon ? '₩' : '$')}290,000 </p>
                                            <span>→ {(showWon ? '₩' : '$')}145,000</span>
                                        </div>
                                    </div>
                                </label>

                                <label className={`option_chk ${planPopRadioValue === 3 ? 'on' : ''}`} htmlFor="price_option3">
                                    <input 
                                        type="radio" 
                                        name="price_option" 
                                        id="price_option3"
                                        onChange={() => checkboxFunc(3)}
                                        checked={planPopRadioValue === 3}
                                    />

                                    <div className="price">
                                        <p>UModeler X All-In-One</p>
                                        <div>
                                            <p>{(showWon ? '₩' : '$')}290,000 </p>
                                            <span>→ {(showWon ? '₩' : '$')}145,000</span>
                                        </div>
                                    </div>
                                </label> */}
                            </div>
                        </div>
                    }


                    <div className="sale_service_btn_box">
                        {saleStep === 2 &&
                            <>
                                <div className="invoice_chk_text">
                                    {lang === 0 ? <>유효한 INVOICE: <span>15</span>개</> : <>Valid INVOICES: <span>15</span></>}
                                    
                                </div>

                                <button
                                    type="button"
                                    className="custom_btn sub"
                                    onClick={() => {

                                    }}
                                >
                                    
                                    {lang === 0 ? <>재입력</> : <>Re-enter</>}
                                </button>
                            </>
                        }

                        {saleStep != 3 &&
                            <button
                                type="button"
                                className="custom_btn"
                                onClick={() => {
                                    SaleServiceStepFunc()
                                }}
                            >
                                
                                {lang === 0 ? <>확인</> : <>Ok</>}
                            </button>
                        }

                        {saleStep === 3 &&
                            <button
                                type="button"
                                className="custom_btn"
                                style={{ margin: '0 auto' }}
                                onClick={() => {
                                    SaleModelBuyFunc()
                                }}
                            >
                                
                                {lang === 0 ? <>다음</> : <>Next</>}
                            </button>
                        }
                        
                    </div>

                    {(buttonCancel || button || longButton) &&
                        <div 
                            className="popup_btn_box"
                            style={{ width: '100%' }}
                        >

                            {buttonCancel && (
                                <button
                                    className="button_cancel"
                                    onClick={() => {
                                        if (func === "setRightFunc") {
                                            setFunction();
                                        } else {
                                            if(cancelFunc) cancelFunc();
                                            dispatch(close());
                                        }
                                    }}
                                >
                                    {buttonCancel}
                                </button>
                            )}
                            {button && (
                                <button
                                    className="button_success"
                                    onClick={() => {
                                            setFunctionSet();
                                    }}
                                >
                                    {button}
                                </button>
                            )}
                            {longButton && (
                                <button
                                    className="button_success long"
                                    onClick={() => {
                                        if (func === "setRightFunc") {
                                            setFunction();
                                        } else {
                                            if(cancelFunc) cancelFunc();
                                            dispatch(close());
                                        }
                                    }}
                                >
                                    {longButton}
                                </button>
                            )}
                        </div>
                    }
                </div>
            </div>
        </>
    );
}
